var map = {
	"./Destination/DestinationReducers": 57137,
	"./Hotel/HotelReducers": 16193,
	"./PromoCode/PromoCodeReducers": 65309,
	"./Tour/TourReducers": 66987,
	"./TourBooking/TourBookingReducers": 24273,
	"./Widget/WidgetReducers": 81487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46580;